export enum BazaNcPayoffDistributionPaymentSource {
    NC = 'NC',
    Dwolla = 'Dwolla',
}

export const bazaNcPayoffDistributionReprocessablePaymentSources: Array<BazaNcPayoffDistributionPaymentSource> = [BazaNcPayoffDistributionPaymentSource.Dwolla];
